import React from 'react';
import { Row, Col, Select } from 'antd';
import { SIZES_RANGE } from '../../consts/sizes';
import { IBaseFilter } from '../../types/plans';

const { Option } = Select;

interface MapFiltersProps {
  filters: IBaseFilter;
  setFilters: (filters: IBaseFilter) => void;
  setUnlocked?: (unlocked: boolean) => void;
  unlocked?: boolean;
}

export const Filters = ({
  filters,
  setFilters,
  setUnlocked = () => null,
  unlocked = true,
}: MapFiltersProps) => {
  const handleChange = (value: string | number | object, field: string) => {
    if (setUnlocked) setUnlocked(false);
    if (!unlocked) return;
    if (typeof value === 'object') {
      if (!filters[field]) filters[field] = {};
      setFilters({
        ...filters,
        [field]: { ...(filters[field] as object), ...value },
      });
      return;
    }
    setFilters({ ...filters, [field]: value });
  };

  const getValueArea = () => {
    if (!filters.meta || !filters.meta.outerArea) return null;
    const key = `${filters.meta.outerArea.gte}${filters.meta.outerArea.lte ? ' - ' + filters.meta.outerArea.lte : '+'}`;
    return key;
  };

  return (
    <Row gutter={[8, 8]} style={{ margin: 10 }}>
      <Col span={8} lg={8}>
        <Select
          placeholder="Sq Ft"
          value={getValueArea()}
          style={{ width: '100%' }}
          onChange={value => handleChange({ outerArea: SIZES_RANGE[value] }, 'meta')}>
          <Option key="all" value="">
            Any
          </Option>
          {Object.entries(SIZES_RANGE).map(([key]) => (
            <Option key={key} value={key}>
              {key}
            </Option>
          ))}
        </Select>
      </Col>
      <Col span={8} lg={8}>
        <Select
          placeholder="Bedrooms"
          value={filters.meta && filters.meta.bedroomCount}
          style={{ width: '100%' }}
          onChange={value => handleChange({ bedroomCount: value }, 'meta')}>
          <Option key="all" value={-1}>
            Any
          </Option>
          <Option key="0" value={0}>
            Studio
          </Option>
          <Option key="1" value={1}>
            1
          </Option>
          <Option key="2" value={2}>
            2
          </Option>
          <Option key="3" value={3}>
            3
          </Option>
          <Option key="4" value={4}>
            4
          </Option>
        </Select>
      </Col>
      <Col span={8} lg={8}>
        <Select
          placeholder="Bathrooms"
          value={filters.meta && filters.meta.bathroomCount}
          style={{ width: '100%' }}
          onChange={value => handleChange({ bathroomCount: value }, 'meta')}>
          <Option key="all" value={-1}>
            Any
          </Option>
          <Option key="bathroomCount-0" value={0}>
            0
          </Option>
          <Option key="bathroomCount-1" value={1}>
            1
          </Option>
          <Option key="bathroomCount-2" value={2}>
            2
          </Option>
        </Select>
      </Col>
    </Row>
  );
};
